import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { ActivityEntry, ActivityEntryText } from 'app/domains/common-ui/ActivityLog';
import { getIcon } from './utils';
export function SignRequestSignatoryOpened(props) {
    const { actor, timestamp } = props;
    const fallbackName = t({
        message: 'Unknown',
        comment: 'Fallback name when user does not exist',
    });
    const userName = (actor === null || actor === void 0 ? void 0 : actor.name) || fallbackName;
    return (<ActivityEntry appearance="info" icon={getIcon('info')} timestamp={timestamp} text={<ActivityEntryText>
          <Trans comment="Esigning request - Signatory opened the document">
            <b>{userName}</b> opened the document
          </Trans>
        </ActivityEntryText>}/>);
}
